import type { CSSProperties } from '@linaria/core';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SyntheticEvent } from 'react';
import DotMenu from '../Icons/DotMenu';
import { palette } from '../styles/colors';
import IconButton from './IconButton';
import "./ButtonModelMenu.linaria.module.css!=!./ButtonModelMenu?./ButtonModelMenu.linaria.module.css?css=H4sIAAAAAAAAA5WSTW7DIBCF9z1FlskCq6SJHZFNb4IgjG0KBgcI/kG9exWnUeJaatUVmvf0PUYzk7HQ0O5MFS9MHNOIpBHQE3z8fMmuVhyodZjrKnVShJrstm1/92BLy7w8a55qkFUdCD48zK2gMg5CF/MqcXZSlbMXI9DJautIZG6N0JPsIILzsLknqR3FrRz6TiXbspMMA3nN9ndXW4pjPuY4/ChTy4SQpkLBtqR4NKZhDsAC4DYE28wYNWfUgtFQhhmh54ReEG4a2ROy/6C47HoTIXHrBDjkmJAXT/Bt5u8NCMlW69pGcGQ1PZs0odjvirdheJ74nxKZAv61j197YHs8Bk/zXgjBl8r3d48NHq55mddG5a5LrfUySGsI497qS4DjdW3odlBf+g2rSaUCAAA="
const menuStyles = "atm_wq_kb7nvz atm_vy_or1blg atm_e2_f6fqlb atm_2d_ivydl7 atm_k4_1piyxwk atm_lo_1v6z61t atm_le_1v6z61t atm_lk_1v6z61t atm_ll_1v6z61t atm_5j_1fwxnve atm_1s473yy_ivydl7 atm_a51zts_6xdddb";
const StyledDots = /*#__PURE__*/styled('span')({
  name: "StyledDots",
  class: "slnk6rw",
  propsAsIs: false
});
interface IButtonModelMenu {
  onClick: (e: SyntheticEvent) => void;
  style?: CSSProperties;
  className?: any;
  css?: any;
}
const ButtonModelMenu = ({
  className,
  onClick,
  style
}: IButtonModelMenu) => {
  const handleOnClickDefault = e => {
    e.stopPropagation();
    e.preventDefault();
    onClick(e);
  };
  return <IconButton onClick={handleOnClickDefault} data-testid="IconButton__ModelMenu" className={cx(menuStyles, className)} style={style}>
            <StyledDots>
                <DotMenu size="33px" color={palette.background} />
            </StyledDots>
        </IconButton>;
};
export default ButtonModelMenu;